import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import omit from 'lodash/omit';

import { setDisplayName } from '../../../../../shared/react-hocs/hoc-helpers';

import withCheckPermission from '../check-permission-hoc';

import ProgressBar from '../progress-bar';
import PageContainer from './main';

function withPageContainer(WrappedComponent, { name, tabs, permission } = {}) {
	class WithPageContainer extends PureComponent {
		componentDidMount() {
			const { check, router } = this.props;

			if (permission && !check(permission)) {
				router.replace('/');
			} else {
				this.fetch();
			}
		}

		componentDidUpdate(prevProps, prevState, snapshot) {
			if (prevProps.location.search !== this.props.location.search) {
				this.fetch();
			}
		}

		fetch() {
			if (this.props.fetchData) {
				this.props.fetchData(omit(this.props, 'fetchData', 'isLoading', 'isError'));
			}
		}

		render() {
			const { isLoading, isError, ...props } = omit(this.props, 'fetchData');

			if (isLoading) {
				return (
					<ProgressBar />
				);
			}

			if (isError) { /* skip */ }

			return (
				<PageContainer name={name} tabs={tabs}>
					<WrappedComponent {...props} />
				</PageContainer>
			);
		}
	}

	setDisplayName(WithPageContainer, WrappedComponent);

	WithPageContainer.propTypes = {
		router: PropTypes.object.isRequired,
		fetchData: PropTypes.func,
		isLoading: PropTypes.bool,
		isError: PropTypes.bool
	};

	return withCheckPermission(WithPageContainer);
}

export default withPageContainer;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/page-container/with-page-container.js